import script from "./SidebarProjects.vue?vue&type=script&setup=true&lang=ts"
export * from "./SidebarProjects.vue?vue&type=script&setup=true&lang=ts"

import "./SidebarProjects.vue?vue&type=style&index=0&id=3c37545e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3c37545e"]])

export default __exports__